import React from "react";
import "./homesection2.css";
import Software from "../../../assets/homepagesoftware.jpg";
import Marketing from "../../../assets/homepagemarketing.jpg";
import Creative from "../../../assets/homepagecreative.jpg";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Homesection2 = () => {
  const { t } = useTranslation("global");
  const { lang } = useParams();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section className="home-seciton2-container">
      <header className="texts">
        <h1>{t("homesection2.heading")}</h1>
        <h2>{t("homesection2.heading2")}</h2>
        {/* <p>{t("homesection2.text")}</p> */}
      </header>
      <div className="card-grid">
        <article className="card">
          <Link to={`/${lang}/SoftwareSolutions`} onClick={scrollToTop}>
            <img src={Software} alt="Software Solution Services" />
            <div className="card-overlay">
              <p className="card-text">{t("homesection2.cardText1")}</p>
            </div>
          </Link>
        </article>
        <article className="card-first">
          <Link to={`/${lang}/AdvertisingAndMedia`} onClick={scrollToTop}>
            <img src={Marketing} alt="Advertising and Media Services" />
            <div className="card-overlay">
              <p className="card-text">{t("homesection2.cardText2")}</p>
            </div>
          </Link>
        </article>
        <article className="card">
          <Link to={`/${lang}/CreativeDesign`} onClick={scrollToTop}>
            <img src={Creative} alt="Creative Design Services" />
            <div className="card-overlay">
              <p className="card-text"> {t("homesection2.cardText3")}</p>
            </div>
          </Link>
        </article>
      </div>
    </section>
  );
};

export default Homesection2;
